// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2in8G","legacyBtn":"MutateMid_legacyBtn__1ilTD"};